import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import SectionEyebrow from "@/components/common/SectionEyebrow";
import StatusBadge from "@/components/common/StatusBadge";
import { publicApi } from "@/lib/api";
import { ArrowRight, Flame, FlaskConical, Mic, FileText, Trophy, GraduationCap, Award, Globe2, Building2 } from "lucide-react";

const ICONS = {
  "beyond-science-summit": Flame,
  "beyond-labs": FlaskConical,
  "beyond-talks": Mic,
  whitepapers: FileText,
  "beyond-science-prize": Trophy,
  "student-circles": GraduationCap,
  "research-fellows": Award,
  ambassadors: Globe2,
  "institutional-partners": Building2,
};

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const [page, setPage] = useState(null);
  useEffect(() => {
    publicApi.programs().then(setPrograms).catch(() => {});
    publicApi.page("programs").then(setPage).catch(() => {});
  }, []);
  const p = page || {};
  return (
    <PublicLayout title="Programs">
      <section className="relative bsca-dark bsca-cosmic bsca-grain -mt-16 md:-mt-20 lg:-mt-[88px] pt-36 md:pt-44 pb-24 overflow-hidden">
        <div className="bsca-field-lines" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14 bsca-fade-up">
          <SectionEyebrow dark>{p.hero?.eyebrow || "Programs"}</SectionEyebrow>
          <h1 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">{p.hero?.headline || "Where the alliance becomes practice."}</h1>
          <p className="mt-6 text-white/75 text-lg max-w-2xl">{p.hero?.subheadline}</p>
        </div>
      </section>

      <section className="bg-[#F8F6F1] py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10 bsca-stagger">
          {programs.map((pr) => {
            const Icon = ICONS[pr.slug] || Flame;
            return (
              <div key={pr.slug} data-testid={`program-card-${pr.slug}`} className="bg-white p-8 hover:bg-[#F8F6F1] transition-colors">
                <div className="flex items-start justify-between">
                  <Icon className="h-6 w-6 text-[#D4AF37]" strokeWidth={1.3} />
                  <StatusBadge status={pr.status} />
                </div>
                <h3 className="mt-5 font-serif text-2xl tracking-tight">{pr.title}</h3>
                <p className="mt-3 text-sm text-[#4B5563] leading-relaxed">{pr.description}</p>
                <div className="mt-5 text-xs text-[#7A5A06] bsca-eyebrow">{pr.audience}</div>
                <Link to="/engage#join" data-testid={`btn-program-${pr.slug}`} className="mt-6 inline-flex items-center bsca-link text-sm">Get involved <ArrowRight className="h-3 w-3 ml-1" /></Link>
              </div>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
}
